import React, { FC, useCallback, useMemo } from 'react';
import {
	EventTicketDto,
	getEventShortLocalInstance,
	makeEventPageLink,
} from '@sweatpals/shared';
import {
	TicketCard as TicketCardUIKit,
} from '@sweatpals/react-ui-kit';
import { copyToClipboard } from '@sweatpals/react-web-shared';

import { getPublicFileUrl } from '../../utils/file.utils';
import DefaultTicketBackground from '@/public/assets/images/ticket-card/default-ticket-background.webp';
import { HOME_PAGE_URL } from '../../constants/env';
import { EventType } from '../../types/event-types';

export interface TicketCardProps {
	ticket: EventTicketDto;
	eventData: EventType;
}

export const TicketCard: FC<TicketCardProps> = ({ ticket, eventData }) => {
	const eventPageUrl = useMemo(() => {
		if (!eventData) {
			return;
		}

		const shortLocalInstance = getEventShortLocalInstance(eventData, eventData.instance);

		return `${HOME_PAGE_URL}/${makeEventPageLink({
			eventAlias: eventData.alias,
			shortLocalInstance: eventData.calculated_is_serial ? shortLocalInstance : undefined,
		})}`;
	}, [eventData]);

	const downloadTicket = useCallback(async (): Promise<void> => {
		if (!ticket.id) {
			return;
		}
	
		window.open(`${process.env.NEXT_PUBLIC_API_URL}/wallet/v1/${ticket.id}/pass`, '_blank');
	}, [ticket.id]);

	const onCopyEventLink = useCallback(async (): Promise<void> => {
		if (!eventPageUrl) {
			return;
		}
		copyToClipboard(eventPageUrl);
	}, [eventPageUrl]);


	return (
		<TicketCardUIKit
			ticket={ticket}
			event={eventData}
			getMediaUrl={(id) => getPublicFileUrl(id)}
			onDownloadTicket={downloadTicket}
			eventPageUrl={eventPageUrl}
			copyToClipboard={copyToClipboard}
			defaultBackgroundImage={DefaultTicketBackground.src}
			onCopyEventLink={onCopyEventLink}
		/>
	);
}; 
